<style scoped lang="scss" src="./Nps.scss"></style>
<template>
  <main class="protocol-screen">
    <section class="protocol-container">
      <div class="title">Resumo da Consulta</div>
      <div class="texts">
        <div class="text">Aqui estão as informações sobre a sua consulta:</div>
      </div>
      <!-- Exibe o Tempo de Espera -->
      <div class="crono">
        <div class="subtitle">Tempo de espera:</div>
        <div class="box">{{ room ? room.tsa_tempo_espera : 'Carregando...' }}</div>
      </div>
      <!-- Exibe a Duração da Consulta -->
      <div class="crono">
        <div class="subtitle">Duração da Consulta:</div>
        <div class="box">{{ room ? room.tsa_duracao_consulta : 'Carregando...' }}</div>
      </div>
      <!-- Avaliacao -->
      <div class="title two">Nos Avalie</div>
      <div class="texts">
        <div class="text">O quão satisfeito você está com nosso sistema?</div>
      </div>
      <div class="emojis">
      <div
        class="emoji"
        v-for="(emoji, index) in emojis"
        :key="index"
        @click="changeEmoji(index)"
      >
        <img alt="Emoji" :src="emoji.clicked ? emoji.colorImage : emoji.pbImage"/>
      </div>
    </div>
      <div class="observation">
        <InputText
          label="Algo a acrescentar?"
          placeholder="Digite aqui..."
          v-model="inputObservation"
        />
      </div>
      <!-- Voltar -->
      <div class="confirm" @click="actConfirm">
        <p>Confirmar</p>
      </div>
    </section>
  </main>
</template>

<script>
import ApiService from "@/services/ApiService";
import FirebaseService from '@/services/FirebaseService'

import InputText from "@/components/input/text/InputText";

export default {
  name: "ProtocolScreen",
  components: {
    InputText
  },

  data() {
    return {
      protocol: "", // Armazena o protocolo gerado
      minutes: "00", // Minutos do cronômetro
      seconds: "00", // Segundos do cronômetro
      intervalId: null, // ID do intervalo do cronômetro
      permissionCamera: false,
      permissionMicrophone: false,
      waitingTime: '00:00',
      emojis: [
        { pbImage: require('@/assets/emojis/1_pb.png'), colorImage: require('@/assets/emojis/1_color.png'), clicked: false },
        { pbImage: require('@/assets/emojis/2_pb.png'), colorImage: require('@/assets/emojis/2_color.png'), clicked: false },
        { pbImage: require('@/assets/emojis/3_pb.png'), colorImage: require('@/assets/emojis/3_color.png'), clicked: false },
        { pbImage: require('@/assets/emojis/4_pb.png'), colorImage: require('@/assets/emojis/4_color.png'), clicked: false },
        { pbImage: require('@/assets/emojis/5_pb.png'), colorImage: require('@/assets/emojis/5_color.png'), clicked: false }
      ],
      clickedEmoji: 0,
      inputObservation: null,

      qsProtocol: null,
      room: null,
      FirebaseService: new FirebaseService()
    };
  },

  watch: {
  },

  beforeDestroy() {
  },

  async mounted() {
    this.ApiService = new ApiService();
    this.qsProtocol = this.$route.query.protocol || null
    console.log('Protocolo', this.qsProtocol)
    if (this.qsProtocol === 'null') {
      await this.FirebaseService.logout();
      this.$router.push({path: "/", query: { reload: 'true' }});
      return
    }

    this.room = await this.ApiService.getRoomByProtocol({ tsa_protocolo: this.qsProtocol })
    if (!this.room) {
      await this.FirebaseService.logout();
      this.$router.push({path: "/", query: { reload: 'true' }});
    }
  },

  methods: {
    changeEmoji (index) {
      // Reseta o estado de "clicked" para todos os emojis
      this.emojis.forEach((emoji, idx) => {
        // Define como false todos os outros emojis
        emoji.clicked = idx === index;
      });
      this.clickedEmoji = index + 1
    },

    async actConfirm () {
      try {
        if (!this.room) {
          return
        }
        
        const payload = {
          tnp_protocolo: this.room.tsa_protocolo,
          tnp_cpf: this.room.tsa_cpf,
          tnp_paciente_nome: this.room.tsa_paciente_nome,
          tnp_profissional_nome: this.room.tsa_profissional_nome,
          tnp_tempo_espera: this.room.tsa_tempo_espera,
          tnp_duracao_consulta: this.room.tsa_duracao_consulta,
          tnp_nota: this.clickedEmoji,
          tnp_observacao: this.inputObservation
        }

        await this.ApiService.saveNps(payload)
      } catch (error) {
        console.error('[FINALIZE NPS ]', error)
      } finally {
        await this.FirebaseService.logout();
        this.$router.push({path: "/", query: { reload: 'true' }});
      }
    }
  }
};
</script>

